import React, { useEffect, useState } from 'react';
import { isNotEmpty, parseClasses } from '../../lib/ep';
import { useCSS } from '../../lib/hooks';

import ActionLink from './ActionLink';

export const RowTitle = (props) => {
	useCSS('comp/grid_table.css');

	return (
		<p class="item_title">
			{(props.onClick != undefined || props._href != undefined) ? (
				<ActionLink
					onClick={props.onClick}
					_href={props._href}
					autotranslate={false}
					_class={{ other:'c' }}
				>{props.children}</ActionLink>
			) : (
				<strong class="c">
					{props.children}
				</strong>
			)}
		</p>
	)
};

export const Column =  (props) => {
	useCSS('comp/grid_table.css');

	const enabled = props?.enabled ?? true;
	if(enabled === false) return null;

	const is_header = (props.item == undefined) ? true : false;
	const is_main = props?.main ?? false;
	const icon = props?.icon ?? false;
	const row = props?.row ?? 0;
	const type = props?.type ?? 'text';
	const is_disabled = props?.is_disabled ?? false;
	const is_blocked = props?.is_blocked ?? false;
	const with_ellipsis = props?.with_ellipsis ?? false;

	const classes = ((isNotEmpty(props, 'class')) ? props.class : '').split(" ");
	classes.push(`is_${(is_header) ? 'header' : 'item'}`);
	classes.push(`is_${type}`);
	if(with_ellipsis) classes.push('gui_cutTextOnOverflow');
	if(!is_header) classes.push(`row_${row}`);
	if(is_main !== false) classes.push('is_main');
	if(!is_header && icon !== false) classes.push(`${icon} gui_small_icon`);
	if((is_disabled || is_blocked) && type != 'actions') classes.push('is_disabled');

	const clean_props = {
		className:classes.join(" "),
		style:props?.style ?? null,
		id:props?.id ?? null,
	};
	/*if(clean_props.item != undefined) delete clean_props.item;
	if(clean_props.enabled != undefined) delete clean_props.enabled;
	if(clean_props.title != undefined) delete clean_props.title;
	if(clean_props.width != undefined) delete clean_props.width;
	if(clean_props.type != undefined) delete clean_props.type;
	if(clean_props.class != undefined) delete clean_props.class;
	if(clean_props.icon != undefined) delete clean_props.icon;
	if(clean_props.row != undefined) delete clean_props.row;
	if(clean_props.main != undefined) delete clean_props.main;
	if(clean_props.is_disabled != undefined) delete clean_props.is_disabled;*/

	if(is_header) {
		return (
			<div {...clean_props}>
				{props.title}
			</div>
		)
	}
	return (
		<div {...clean_props}>
			{props.children(props.item)}
		</div>
	)
};

export const MarkupTable = (props) => {
	useCSS('comp/grid_table.css');

	const table_id = props?.table_id ?? '';

	const table_styles = props.column_defs ?? {};
	let classname = props?.classname ?? 'grid_table';

	return (
		<div class="gui_grid">
			<div id={table_id} class={classname} style={table_styles}>
				{props.children}

			</div>
		</div>
	)
};

export const Header = (props) => {
	useCSS('comp/grid_table.css');

	return (
		<div className='is_header'>
			{props.children}
		</div>
	)
}
export const RowItem = (props) => {
	useCSS('comp/grid_table.css');

	return (
		<div className='is_item'>
			{props.children}
		</div>
	)
}

const TabledItemsList = ({ items, columns, ...props }) => {
	useCSS('comp/grid_table.css');
	const [ disabled_items, setDisabledItems ] = useState(props?.disabled_items ?? []);
	const empty_message = props?.empty_message ?? false;
	const table_id = props?.table_id ?? '';
	const start_at = props?.start_at ?? 1;
	useEffect(() => {
		if(props.disabled_items == disabled_items) return;

		setDisabledItems(props?.disabled_items ?? []);
	}, [ props.disabled_items ]);

	if(items == undefined || !items || items.length == 0) {
		if(empty_message === false) return null;

		return (
			<div class="grid_table is_empty">
				<p>{empty_message}</p>
			</div>
		)
	}

	const background_color = props?.background_color ?? false;	// main background of the table (by default it's "--main-bg-color")
	const max_height = props?.max_height ?? null;	// if defined, defines the height at which the table will have scrolling overflow
	const sticky_actions = props?.sticky_actions ?? false;	// if true, the actions column will be sticked to the right
	
	
	const block_items = props?.block_items ?? [];

	// if defined, will override the default column definition of the table (i.e. all columns having equal width except the main, which is doubled)
	let column_defs = props?.column_defs ?? false;
	if(column_defs === false) {
		const col_defs = [];
		
		columns.map((c) => {
			const is_main = c?.props?.main ?? false;
			const type = c?.props?.type ?? 'text';
			col_defs.push((is_main) ? '2fr' : ((type == 'counter') ? '4ch' : '1fr'));
		});

		column_defs = {
			gridTemplateColumns:col_defs.join(" "),
		};
	}
	if(column_defs === false) column_defs = {};

	const table_styles = column_defs;

	if(max_height != undefined && table_styles['--table-max-h'] == undefined) {
		table_styles['--table-max-h'] = (max_height !== false) ? max_height : '1000dvh';
	}
	if(background_color !== false) table_styles['--main-bg-color'] = background_color;
	if(props.styles != undefined) table_styles = { ...table_styles, ...props.styles };

	let classname = props?.classname ?? 'grid_table';
	if(sticky_actions) classname += ' sticky_actions';
	classname = parseClasses(classname, props._class, 'other');

	return (
		<div class="gui_grid">
			<div id={table_id} class={classname} style={table_styles}>
				{columns.map((column, c) => {
					return React.cloneElement(column, { key:`header_${table_id}_${c}` });
				})}

				{items.map((item, i) => {
					const is_disabled = (disabled_items.includes(i)) ? true : false;
					const is_blocked = (block_items.includes(i)) ? true : false;
					return (
						<React.Fragment key={`row_${table_id}_${start_at}_${i}`}>
							{columns.map((column, c) => {
								return React.cloneElement(column, { item, key:`${table_id}_${start_at}_${i}_${c}`, row:i, is_disabled, is_blocked });
							})}
						</React.Fragment>
					)
				})}
			</div>
		</div>
	)
};

export default TabledItemsList;